"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemMap = void 0;
exports.systemMap = {
    'http://terminology.hl7.org/CodeSystem/v3-ActCode': 'ActCode',
    'http://terminology.hl7.org/CodeSystem/v3-ActMood': 'ActMood',
    'http://terminology.hl7.org/CodeSystem/v3-ActPriority': 'ActPriority',
    'http://terminology.hl7.org/CodeSystem/v3-ActReason': 'ActReason',
    'http://terminology.hl7.org/CodeSystem/v3-ActRelationshipType': 'ActRelationshipType',
    'http://terminology.hl7.org/CodeSystem/v3-ActStatus': 'ActStatus',
    'http://terminology.hl7.org/CodeSystem/v3-AddressUse': 'AddressUse',
    'http://terminology.hl7.org/CodeSystem/v3-AdministrativeGender': 'AdministrativeGender',
    'http://terminology.hl7.org/CodeSystem/v2-0001': 'AdministrativeSex',
    'https://www.cdc.gov/nhsn/cdaportal/terminology/codesystem/cdcnhsn.html': 'CDCNHSN',
    'urn:oid:2.16.840.1.113883.6.238': 'CDCREC',
    'http://www.ada.org/cdt': 'CDT',
    'http://www.ama-assn.org/go/cpt': 'CPT',
    'http://hl7.org/fhir/sid/cvx': 'CVX',
    'http://terminology.hl7.org/CodeSystem/v3-Confidentiality': 'Confidentiality',
    'http://terminology.hl7.org/CodeSystem/v2-0112': 'DischargeDisposition',
    'http://terminology.hl7.org/CodeSystem/v3-EntityNamePartQualifier': 'EntityNamePartQualifier',
    'http://terminology.hl7.org/CodeSystem/v3-EntityNameUse': 'EntityNameUse',
    'http://www.nlm.nih.gov/research/umls/hcpcs': 'HCPCS',
    'https://www.cdc.gov/nhsn/cdaportal/terminology/codesystem/hsloc.html': 'HSLOC',
    'http://hl7.org/fhir/sid/icd-10-cm': 'ICD10CM',
    'http://www.cms.gov/Medicare/Coding/ICD10': 'ICD10PCS',
    'http://hl7.org/fhir/sid/icd-9-cm': 'ICD9CM',
    'http://loinc.org': 'LOINC',
    'http://terminology.hl7.org/CodeSystem/v3-LanguageAbilityMode': 'LanguageAbilityMode',
    'http://terminology.hl7.org/CodeSystem/v3-LanguageAbilityProficiency': 'LanguageAbilityProficiency',
    'http://terminology.hl7.org/CodeSystem/v3-LivingArrangement': 'LivingArrangement',
    'http://www.nlm.nih.gov/research/umls/MED-RT': 'MED-RT',
    'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus': 'MaritalStatus',
    'http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl': 'NCI',
    'http://hl7.org/fhir/ndfrt': 'NDFRT',
    'http://nucc.org/provider-taxonomy': 'HealthCareProviderTaxonomy',
    'https://www.cms.gov/Medicare/Medicare-Fee-for-Service-Payment/HospitalAcqCond/Coding': 'PresentOnAdmission',
    'http://terminology.hl7.org/CodeSystem/v3-NullFlavor': 'NullFlavor',
    'http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation': 'ObservationInterpretation',
    'http://terminology.hl7.org/CodeSystem/v3-ObservationValue': 'ObservationValue',
    'http://terminology.hl7.org/CodeSystem/v3-ParticipationFunction': 'ParticipationFunction',
    'http://terminology.hl7.org/CodeSystem/v3-ParticipationMode': 'ParticipationMode',
    'http://terminology.hl7.org/CodeSystem/v3-ParticipationType': 'ParticipationType',
    'http://www.nlm.nih.gov/research/umls/rxnorm': 'RXNORM',
    'http://terminology.hl7.org/CodeSystem/v3-ReligiousAffiliation': 'ReligiousAffiliation',
    'http://terminology.hl7.org/CodeSystem/v3-RoleClass': 'RoleClass',
    'http://terminology.hl7.org/CodeSystem/v3-RoleCode': 'RoleCode',
    'http://terminology.hl7.org/CodeSystem/v3-RoleStatus': 'RoleStatus',
    'http://snomed.info/sct': 'SNOMEDCT',
    'https://nahdo.org/sopt': 'SOP',
    'http://unitsofmeasure.org': 'UCUM',
    'http://www.nlm.nih.gov/research/umls': 'UMLS',
    'http://fdasis.nlm.nih.gov': 'UNII',
    'http://terminology.hl7.org/CodeSystem/v3-MediaType': 'MediaType'
};
